import { h, Fragment } from "preact";

export default function ShippingMethodOptions({
  deliveryGroup,
  deliveryOptionHandle,
  setDeliveryOptionHandle,
}) {
  return (
    <div className="save-quote__shipping-method-options">
      {deliveryGroup.deliveryOptions.map((deliveryOption) => (
        <label class="radio-label">
          <input
            type="radio"
            class="radio-input"
            value={deliveryOption.handle}
            name={deliveryGroup.id}
            onChange={(e) => setDeliveryOptionHandle(e.target.value)}
            checked={deliveryOption.handle === deliveryOptionHandle}
          />
          <div class="radio-circle"></div>
          {`${deliveryOption.title} (${window.formatMoney(deliveryOption.estimatedCost.amount, false, deliveryOption.estimatedCost.currencyCode)})`}
        </label>
      ))}
    </div>
  );
}
